import HotelStrategyDetailBaseRoute from 'lumen/routes/hotel/strategy/detail-base';
import { TYPE_ID_POS } from 'lumen/utils/constants/rate-strategy-constants';

export default class HotelStrategyPosRoute extends HotelStrategyDetailBaseRoute {
  type = TYPE_ID_POS;
}
